import { FunctionComponent, ReactNode, useEffect } from 'react';
import { useDispatch, useStore } from 'react-redux';
import { setReduxDraftAction as reduxSetFullDraftAction } from '@/redux/draft/actions/setReduxDraftAction';
import { setDraftDispatch } from '@/redux/draft/draftDispatch';
import { verifyDraft } from '@/redux/draft/utils/verifyDraft';
import { StoreDispatch, StoreState } from '@/redux/types';
import { DraftContext } from './DraftContext';
import { DraftViewer } from './DraftViewer';
import { reducerWithHistory } from './draftState/history/reducerWithHistory';
import { useDraft } from './draftState/useDraft';

interface DraftViewerReduxProps {
  children?: ReactNode;
  menuHeight?: number;
  readonly?: boolean;
  onShowEdit?: () => void;
}

export const DraftViewerRedux: FunctionComponent<DraftViewerReduxProps> = ({
  menuHeight,
  readonly,
  onShowEdit,
  children,
}) => {
  const reduxDispatch = useDispatch<StoreDispatch>();
  const store = useStore<StoreState>();

  const [draft, dispatch] = useDraft(() => store.getState().draft, reducerWithHistory);

  useEffect(() => {
    verifyDraft(draft, reduxDispatch);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    reduxDispatch(reduxSetFullDraftAction(draft));
  }, [reduxDispatch, draft]);

  useEffect(() => {
    reduxDispatch(setDraftDispatch(dispatch));
  }, [reduxDispatch, dispatch]);

  return (
    <DraftContext.Provider value={dispatch}>
      <DraftViewer
        draft={draft}
        menuHeight={menuHeight}
        readonly={readonly}
        onShowEdit={onShowEdit}
      >
        {children}
      </DraftViewer>
    </DraftContext.Provider>
  );
};
